/*
 * @Descripttion: 
 * @Author: panyufeng
 * @Date: 2025-04-17 10:48:45
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-04-17 11:11:19
 */
import service from '@/utils/request'

// 列表
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: 'operation/gabApiErrLog/page',
    data: params
  })

// 企业uuid （下拉控件）
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: 'admin/enterprise/dropdownOfEnterprise',
    data: params
  })


// 单位证书编号 （下拉控件）
export const enterpriseViolationSettingQuery = (params: any) =>
  service.request({
    method: 'post',
    url: '/enterpriseViolationSetting/query',
    data: params
  })
